import type { Currency } from "@/Apollo/schema";

/**
 * The currency listings are priced in, cart and checkout money is in, and sellers are paid in:
 * EUR, until multi-currency Phase 2 (charging in the buyer's currency) and Phase 3 (sellers'
 * own currency). The one seam for an amount that comes without a currency, as the apps'
 * `sellerCurrency()`, so those phases change it here rather than in scattered `Currency.Eur`
 * literals (WHO-5142). A buyer's display currency is never this: it comes from
 * `useDisplayCurrency()`.
 */
// A literal with a type-only import, so static files that import this don't load the generated
// schema module at runtime (see asking-price.utils.ts).
export const LISTING_CURRENCY = "EUR" as Currency;
